document.addEventListener("DOMContentLoaded", () => {
  initUgcVideoSliders();
});

document.addEventListener("shopify:section:load", () => {
  initUgcVideoSliders();
});

function initUgcVideoSliders() {
  const slides = document.querySelectorAll(".slidev8:not([data-ugc-initialized])");

  function pauseAllVideos(exceptVideo = null) {
    document.querySelectorAll(".tiktok-videov8").forEach((video) => {
      if (video !== exceptVideo && video.tagName === "VIDEO") {
        video.pause();
        const slide = video.closest(".slidev8");
        if (slide) {
          const playButton = slide.querySelector(".play-buttonv8");
          const pauseButton = slide.querySelector(".pause-buttonv8");
          if (playButton) playButton.style.display = "flex";
          if (pauseButton) {
            pauseButton.style.display = "none";
            pauseButton.classList.add("hiddenv8");
          }
        }
      }
    });
  }

  slides.forEach((slide) => {
    slide.setAttribute("data-ugc-initialized", "true");

    const playButton = slide.querySelector(".play-buttonv8");
    const pauseButton = slide.querySelector(".pause-buttonv8");
    const video = slide.querySelector(".tiktok-videov8");

    if (!video || video.tagName !== "VIDEO") return;

    let hidePauseButtonTimeout;

    function showPauseButton() {
      pauseButton.classList.remove("hiddenv8");
      clearTimeout(hidePauseButtonTimeout);
      hidePauseButtonTimeout = setTimeout(() => {
        if (!video.paused) {
          pauseButton.classList.add("hiddenv8");
        }
      }, 1200);
    }

    playButton.addEventListener("click", () => {
      pauseAllVideos(video);
      video.play();
    });

    pauseButton.addEventListener("click", () => {
      video.pause();
    });

    video.addEventListener("play", () => {
      pauseAllVideos(video);
      playButton.style.display = "none";
      pauseButton.style.display = "flex";
      showPauseButton();
    });

    video.addEventListener("pause", () => {
      playButton.style.display = "flex";
      pauseButton.style.display = "none";
      pauseButton.classList.add("hiddenv8");
    });

    video.addEventListener("click", () => {
      if (video.paused) {
        pauseAllVideos(video);
        video.play();
      } else {
        showPauseButton();
      }
    });

    video.addEventListener("mousemove", showPauseButton);
    video.addEventListener("touchstart", showPauseButton, { passive: true });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!entry.isIntersecting && !video.paused) {
          video.pause();
        }
      });
    },
    { threshold: 0.35 }
  );

  document.querySelectorAll(".tiktok-videov8").forEach((video) => {
    if (video.tagName === "VIDEO") {
      observer.observe(video);
    }
  });
}
